"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
exports.default = (0, core_1.makeStyles)({
    multiSelect: {
        fontSize: 14,
        width: '100%',
        height: 20,
        '&::before': {
            border: 'none',
        },
    },
    displayBlock: {
        display: 'block',
    },
});
